














import linkDirective from '@/shared/directives/link-directive';
import ICategory from '../models/category';
import { defineComponent, onMounted, PropType } from "@vue/composition-api";
import { useGetters } from "vuex-composition-helpers";

    declare global {
        interface Window {
            dataLayer: any[];
        }
    }
    export default defineComponent({
        name: "Category",
        directives: {
            linkDirective
        },
        props: {
            category: { type: Object as PropType<ICategory>, required: true }
        },
        setup(_, { emit }: { emit: (event: string, ...args: any[]) => void }) {
            onMounted(() => {
                if (window.dynamicColorSystem && typeof window.dynamicColorSystem.applyDynamicColors === 'function') {
                    window.dynamicColorSystem.applyDynamicColors()
                }
            })

            const { selectCategoryUrl } = useGetters(['selectCategoryUrl'])
            const trackCategoryClick = (category: ICategory) => {
                const url = selectCategoryUrl.value(category)
                const clickText = category.name
                const clickUrl = resolveUrl(url)
                pushDataLayerEvent('tile_click', clickText, clickUrl)
            }

            const trackCategorySelect = (category: ICategory) => {
                emit('select', category)
                const clickText = category.name
                pushDataLayerEvent('tile_click', clickText, 'no link')
            }

            const resolveUrl = (url: string): string => {
                if (!url) {
                    return '';
                }
                return url.startsWith('http')
                    ? url
                    : `${window.location.origin}${url}`;
            };

            const pushDataLayerEvent = (event: string, clickText: string, clickUrl: string) => {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                    event,
                    click_text: clickText,
                    click_url: clickUrl
                })
            }

            return {
                selectCategoryUrl,
                trackCategoryClick,
                trackCategorySelect
            }
        }
    })
